import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { ItemLineWithInfo } from './ItemLineWIthInfo';

interface ProviderLine {
  boldedHeader?: string;
  header?: string;
  line1?: string;
  line2?: string;
  line3?: string;
}

interface Disclaimer {
  title: string;
  description?: string;
}
interface ProviderCardProps {
  providersLines: ProviderLine[];
  disclaimer?: Disclaimer;
  providerHeadline: string;
}

export const IntProviderCard = ({ providersLines, disclaimer }: ProviderCardProps) => (
  <div className='p-[24px] pb-[16px] w-full border border-outline-primary-bw-03 rounded-[12px] h-full'>
    <div className='flex flex-col h-full'>
      <div className='flex w-full flex-col justify-between h-full'>
        <div>
          {providersLines.map((providerLine) => (
            <div key={providerLine.header}>
              {providerLine.boldedHeader && (
                <Heading.H10 fontWeight={FontWeight.MEDIUM} className=' mb-[6px]' id='provider_headLine'>
                  {providerLine.boldedHeader}
                </Heading.H10>
              )}
              <ItemLineWithInfo id={providerLine.header || 'id'} {...providerLine} />
            </div>
          ))}
        </div>

        {disclaimer?.title && (
          <Heading.H12 id='disclaimer_title' className='text-text-main-secondary '>
            {disclaimer.title}
          </Heading.H12>
        )}
      </div>
      {disclaimer?.description && (
        <Heading.H12
          id='disclaimer_description'
          className='text-text-main-secondary whitespace-pre-line  border-t border-bw03 pt-[16px] mt-[16px]'
        >
          {disclaimer.description.split('.').join('.\n')}
        </Heading.H12>
      )}
    </div>
  </div>
);
